import { setConsents } from "../../state/ducks";
import { selectConsentsAppType, selectConsentsMarket } from "../../state/selectors";
import { dispatch, getState } from "../../state/store";
import httpClient from "../httpClient";

const apiUrl = process.env.REACT_APP_API_URL;

const getRequestData = async (endpoint) => {
  return `${apiUrl}/consent-management/${endpoint}`;
};

const fetchConsents = async (consentsMarket, appType) => {
  const consentsMarketValue = consentsMarket || selectConsentsMarket()(getState());
  const appTypeValue = appType || selectConsentsAppType()(getState());

  const baseUrl = await getRequestData("get-consents");
  const url = `${baseUrl}?market=${consentsMarketValue}&appType=${appTypeValue}`;

  const data = await httpClient.get(url);

  if (data?.data) {
    dispatch(setConsents(data?.data));
  }

  return data?.data;
};

const fetchConsent = async (id) => {
  const baseUrl = await getRequestData("get-consent");
  const url = `${baseUrl}?id=${id}`;

  const data = await httpClient.get(url);

  return data?.data;
};

const publishNewConsent = async (consentConfig) => {
  const url = await getRequestData("publish-new-consents");

  const data = await httpClient.post(url, { data: consentConfig });

  return data?.data;
};

const activateConsent = async (consentConfig) => {
  const url = await getRequestData("mark-draft-consents-as-active");

  const data = await httpClient.put(url, { data: consentConfig });

  return data?.data;
};

const deleteDraftConsent = async (id) => {
  const url = await getRequestData("delete-draft-consents");

  return await httpClient.remove(url, { data: { id } });
};

const updateConsentElements = async (consent) => {
  const url = await getRequestData("update-consent");

  const data = await httpClient.put(url, { data: consent });

  return data?.data;
};

const updateConsentElementsTexts = async (consentElements, index = 0) => {
  if (consentElements && consentElements?.length > index) {
    await updateSingleConsentElementTexts(consentElements[index]);

    const newIndex = index + 1;

    if (consentElements?.length > newIndex) {
      return updateConsentElementsTexts(consentElements, newIndex);
    }
  }
};

const updateSingleConsentElementTexts = async (consent) => {
  const url = await getRequestData("add-consents-item-localization-texts");
  const data = await httpClient.post(url, { data: consent });

  return data?.data;
};

const consentsService = {
  fetchConsents,
  fetchConsent,
  publishNewConsent,
  activateConsent,
  deleteDraftConsent,
  updateConsentElements,
  updateConsentElementsTexts
};

export default consentsService;
